<template>
    <div class="mr-2">
        <v-icon v-if="!connected" color="error">mdi-lan-disconnect</v-icon>
        <v-icon v-if="connected" color="success">mdi-lan-connect</v-icon>
    </div>
</template>

<script>
import User from "@/models/User/User";

export default {
    name: "SocketStatus",
    sockets: {
        'user:joined'() {
            if (!User.loggedInUser()) {
                this.connected = false;
                return;
            }

            this.connected = true;
        },
        disconnect() {
            this.connected = false;
        },
    },
    data() {
        return {
            connected: false,
        }
    },
}
</script>
